import { IActionFn, IPageData } from '@/store/types';
import { IModuleState } from './types';
import { downloadFile } from '@/utils/helper';
import { $file, $http } from '@/axios';
import store from '@/store';

// 查询模块列表
export const queryDigitalBlocks: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalBlocks', { ...state.list, loading: true });
    const res: IPageData = await $http.post('/v1/asset/block/pagelist', payload);
    commit('setDigitalBlocks', { data: res.list, pageNum: res.pageNum, pageSize: res.pageSize, total: res.total });
  } catch (e) {
    commit('setDigitalBlocks', { data: [], pageNum: 0, pageSize: 0, total: 0 });
  }
};

// 查询模块详情
export const queryDigitalBlockDetail: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setDigitalBlockDetail', { data: null, loading: true });
    const res = await $http.get(`/v1/asset/block/${payload}/detail`);
    commit('setDigitalBlockDetail', { data: res, loading: false });
  } catch (e) {
    commit('setDigitalBlockDetail', { data: null, loading: false });
  }
};

// 查询模板列表
export const queryDigitalBlockMods: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setDigitalBlockMods', { data: [], loading: true });
    const res = await $http.post('/v1/data/asset/block/blockmods');
    commit('setDigitalBlockMods', { data: res, loading: false });
  } catch (e) {
    commit('setDigitalBlockMods', { data: [], loading: false });
  }
};

// 查询模块组装类型
export const queryBlockStructTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setBlockStructTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/ModuleStructureType');
    commit('setBlockStructTypes', { data: res });
  } catch (e) {
    commit('setBlockStructTypes', { data: [] });
  }
};

// 查询控制件组装位置类型
export const queryLocationTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setLocationTypes', { data: [], loading: true });
    const res = await $http.get('/common/chooseoptions/componentLocatingType');
    commit('setLocationTypes', { data: res });
  } catch (e) {
    commit('setLocationTypes', { data: [] });
  }
};

// 查询模块状态类型
export const queryBlockStatusTypes: IActionFn<IModuleState> = async ({ commit }) => {
  try {
    commit('setBlockStatusTypes', { data: [], loading: true });
    const res: any[] = await $http.get('/common/chooseoptions/ModuleItemStatus');
    const data =  [{ optionKey: '', optionValue: '全部' } , ...res];
    commit('setBlockStatusTypes', { data });
  } catch (e) {
    commit('setBlockStatusTypes', { data: [] });
  }
};

// 查询摆放轴
export const queryBlockAxis: IActionFn<IModuleState> = async ({ commit, state }) => {
  try {
    commit('setDigitalBlockAxis', { ...state.blockAxis, loading: true });
    const res = await $http.get('/common/chooseoptions/Axis');
    commit('setDigitalBlockAxis', { data: res });
  } catch (e) {
    commit('setDigitalBlockAxis', { data: [] });
  }
};

// 编辑模块基本信息
export const editDigitalBlock: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setLoading', true);
    await $http.post('/v1/asset/block/modify', payload);
    store.commit('common/setToast', { visible: true, text: '编辑成功' });
  } finally {
    commit('setLoading', false);
  }
};

// 删除
export const deleteDigitalBlock: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/v1/asset/block/delete', payload); // 删除
    await $http.post('v1/asset/block/resetcreated', payload); // 将入库状态还原为新建状态
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 上下架
export const shelfDigitalBlock: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    await $http.post('/v1/asset/block/publish', payload);
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 批量刷新索引
export const refreshDigitalBlockIndex: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setConfirm', { ...state.confirm, loading: true });
    // await $http.post('/model/type/item/batch/refresh', payload);
    await $http.post('/v1/asset/item/refresh', payload);
    store.commit('common/setToast', { visible: true, text: '索引刷新成功' });
  } finally {
    commit('setConfirm', { visible: false });
  }
};

// 更新模块缩略图
export const updateDigitalBlockThumb: IActionFn<IModuleState> = async ({ commit, state }, payload) => {
  try {
    commit('setDigitalBlockThumb', { ...state.thumb, loading: true });
    const res = await $http.post('/v1/asset/block/modifyimg', payload);
    commit('setDigitalBlockThumb', { data: res, loading: false });
  } catch (e) {
    commit('setDigitalBlockThumb', { data: null, loading: false });
  }
};

// 调整模块颜色
export const updateDigitalBlockColor: IActionFn<IModuleState> = async ({ commit }, payload) => {
  await $http.post('/v1/asset/block/modifycolor', payload);
  store.commit('common/setToast', { visible: true, text: '颜色保存成功' });
};

// 导出价格
export const exportDigitalBlockPrice: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    commit('setModalLoading', true);
    const res: { blob: Blob; filename: string } = await $file.post('/v1/data/asset/block/export', payload);
    downloadFile(res.blob, '家具模块价格列表');
  } finally {
    commit('setModalLoading', false);
  }
};

// 删除模块过滤项配置
export const deleteDigitalBlockFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/block/filterdelete', payload);
    return true;
  } catch (e) {
    return false;
  }
};

// 保存过滤配置
export const saveBlockFilter: IActionFn<IModuleState> = async ({ commit }, payload) => {
  try {
    await $http.post('/v1/asset/block/filterbatchmodify', payload);
    store.commit('common/setToast', { visible: true, text: '保存成功' });
  } catch (e) {
    return;
  }
};
